import * as React from 'react';
import { bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';
import * as actions from '../../../actions';

/**
 * Набор местных экшнов, привязанных к диспатчу
 * */
export var useActions = function useActions() {
  var dispatch = useDispatch();
  return React.useMemo(function () {
    return bindActionCreators(actions, dispatch);
  }, [dispatch]);
};